/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { ListStore } from '../../../store';
// 沉浸式
import { useMaximize } from '@src/hooks/app';
import { setlocal, getlocal, isIOS } from '@src/utils';
// 统计
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { setAppQueryNoIfengsp } from '@src/utils/url';
// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';
import { devPath } from '@src/constants';

const OpenVideo = ({ content }) => {
    const { positive, dramaSeries } = content;

    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo, gags, gagsList, isNightMode } = listStates;

    // 获取时间栏高度
    const statusBarHeight = useMaximize();

    // 视频引用（端内）
    const videoRef = useRef();

    // 设置节点尺寸（后续赋值给视频）
    const [rect, setRect] = useState({ top: '', left: '', width: '', height: '' });

    // 统计
    // 自动联播page
    const sendContinuePage = (
        index, // 从0开始
    ) => {
        const source = positive.findIndex(item => item.base62Id === currentVideo.base62Id);
        let sourceId = '';

        // 正片
        if (source > -1) {
            sourceId = positive[index].base62Id;
        } else {
            // 花絮
            sourceId = gags[index].base62Id;
        }

        pageStatistics({
            behavior: 'page',
            id: `video_${sourceId}`, // 视频id
            type: 'video',
            ref: `phmovie_${dramaSeries.base62Id}`, // 剧集id
            reftype: window.encodeURIComponent('editor|||||||'),
            rnum: index,
            showtype: 'choiceepisode',
            ptype: 'order',
            atype: 'auto',
            pagetag: '', // 手动clear
        });
    };
    // 曝光
    const sendContinueExposure = (
        index, // 从0开始
    ) => {
        const source = positive.findIndex(item => item.base62Id === currentVideo.base62Id);
        let sourceId = '';

        // 正片
        if (source > -1) {
            sourceId = positive[index].base62Id;
        } else {
            // 花絮
            sourceId = gags[index].base62Id;
        }

        Grounds.expose({
            behavior: 'pageinfo',
            // environment: 'client',
            id: `video_${sourceId}`, // 视频id
            rnum: `${index}`,
            reftype: 'editor|||||||',
            ref: `phmovie_${dramaSeries.base62Id}`, // 剧集id
            src: '',
            showtype: 'choiceepisode',
            pagetype: 'video',
        });
    };

    // 记录当前秒数
    const setlocalVideoTime = currentTime => {
        // 为0直接退出不记录
        if (String(currentTime) === '0') {
            return;
        }

        const currentIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        if (currentIndex > -1) {
            // 正片
            const { params } = content;
            const history = getlocal('history');

            const historyObj = JSON.parse(JSON.stringify(history));

            const dramaSeries = historyObj.find(item => item.id === params.id);

            const { videoSeries } = dramaSeries;
            const data = videoSeries.find(item => item.id === currentVideo.base62Id);

            // 传入当前观看的集数
            if (positive[currentIndex].extText) {
                dramaSeries.currentIndex = positive[currentIndex].extText;
            } else {
                dramaSeries.currentIndex = currentIndex;
            }

            // 已经到最后自动跳到最开始
            if (currentVideo.duration - '5' <= currentTime) {
                data.currentTime = '0';
            } else {
                data.currentTime = String(currentTime);
            }

            setlocal('history', historyObj);
        } else {
            // 花序
            const { params } = content;
            const history = getlocal('history');

            const historyObj = JSON.parse(JSON.stringify(history));

            const dramaSeries = historyObj.find(item => item.id === params.id);

            const { videoSeries } = dramaSeries;
            const data = videoSeries.find(item => item.id === currentVideo.base62Id);

            data.currentTime = String(currentTime);
            // 设置类型
            data.type = 'gags';

            setlocal('history', historyObj);
        }
    };

    // 添加视频监听
    useEffect(
        () => {
            if (currentVideo.videoPlayUrl) {
                sendContinuePage(0);
                window.videoCallback = (eventType, currentTime) => {
                    // 记录视频当前秒数
                    if (eventType === 'duration') {
                        // ios：秒/安卓：毫秒
                        const time = isIOS() ? Math.floor(currentTime) : Math.floor(currentTime / 1000);

                        setlocalVideoTime(time);
                    }
                    // 自动联播
                    if (eventType === 'end') {
                        const currentIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

                        // 正片
                        if (currentIndex > -1) {
                            if (positive.length - 1 > currentIndex) {
                                changeListStates({
                                    currentVideo: positive[currentIndex + 1],
                                    gags: gagsList[currentIndex + 1],
                                });
                                // 自动联播统计
                                sendContinuePage(currentIndex + 1);
                                sendContinueExposure(currentIndex + 1); // 曝光
                            }
                        } else {
                            // 花絮
                            const currentIndex = gags.findIndex(item => item.base62Id === currentVideo.base62Id);

                            if (currentIndex > -1) {
                                if (gags.length - 1 > currentIndex) {
                                    changeListStates({
                                        currentVideo: gags[currentIndex + 1],
                                    });
                                    // 自动联播统计
                                    sendContinuePage(currentIndex + 1);
                                    sendContinueExposure(currentIndex + 1); // 曝光
                                }
                            }
                        }
                    }
                };
                // 关闭webview
                window.reservedback = () => {
                    if (window.grounds) {
                        setTimeout(() => {
                            window.grounds.destoryVideo();
                        }, 100);

                        window.grounds.close();
                    }
                };
            }
        },
        [currentVideo],
    );

    // 1.设置DOM高度
    useEffect(
        () => {
            if (statusBarHeight) {
                // 获取状态栏高度
                if (window.grounds && videoRef.current) {
                    const deviceInfo = window.grounds.getDeviceInfo();
                    const os = deviceInfo.getOs();
                    const isIos = os.indexOf('ios') !== -1;
                    const ratio = isIos ? 1 : window.devicePixelRatio;

                    const domRect = videoRef.current.getBoundingClientRect();
                    const top = String(Math.floor(domRect.top * ratio));
                    const left = String(Math.floor(domRect.left * ratio));
                    const width = String(Math.floor(domRect.width * ratio));
                    const height = String(Math.ceil(domRect.height * ratio)); // 向上取整：去除黑边

                    setRect({ top, left, width, height });
                    // alert(height);
                    // 记录视频的高度(注意：不计算像素比)
                    changeListStates({
                        statusBarHeight,
                        videoHeight: String(Math.floor(domRect.height)),
                    });
                }
            }
        },
        [statusBarHeight],
    );

    // 3.渲染视频信息
    const renderVideo = () => {
        const url = currentVideo.videoPlayUrl;

        // 本地记录
        const history = getlocal('history');

        const { params, dramaSeries } = content;

        const historyObj = JSON.parse(JSON.stringify(history));

        const dramaSeriesObj = historyObj.find(item => item.id === params.id);

        let currentTime = '0';

        if (dramaSeriesObj?.videoSeries) {
            const { videoSeries } = dramaSeriesObj;

            const data = videoSeries.find(item => item.id === currentVideo.base62Id);

            // 设置视频播放时间
            currentTime = String(data?.currentTime || '0');
        }

        // 设置投屏列表
        const gylist = [];

        for (let i = 0; i < positive.length; i++) {
            gylist.push({
                type: 'videoSeries',
                id: positive[i].base62Id,
                title: positive[i].title,
                staticId: `video_${positive[i].base62Id}`,
                videoURL: positive[i].videoPlayUrl,
            });
        }

        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${currentVideo.base62Id}`,
            );
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`,
            );
        }

        const finalTitle =
            positive?.length === 1
                ? dramaSeries.title
                : currentVideo?.title2
                    ? `${dramaSeries.title}|${currentVideo?.title2}`
                    : currentVideo?.title
                        ? currentVideo?.title
                        : dramaSeries.title;

        const option = {
            ad: [],
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            time: currentTime,
            autoplay: 'true',
            loop: 'false',
            poster: currentVideo.posterUrl,
            zt: '',
            dm: '',
            lm: '',
            keywords: '',
            vid: '',
            du: '',
            position: 'fixed',
            openTV: true,
            tvConfig: {
                id: dramaSeries.base62Id, // '8CJTwuaK3KJ'
                videoURL: currentVideo.videoPlayUrl,
                type: 'videoSeries',
                staticId: `video_${dramaSeries.base62Id}`,
                title: currentVideo.title,
                anthologies: [
                    {
                        id: dramaSeries.base62Id,
                        gylist,
                    },
                ],
            },
            openShare: true, // {boolean} 是否开启设置功能 默认false
            shareConfig: {
                shareurl: finalUrl,
                title: finalTitle,
                desc: dramaSeries.summary,
                thumbnail: dramaSeries.posterUrl,
                shareInfo: {
                    weiboshareurl: '',
                },
            },
            reservedback: true,
            reservedbackfn: 'reservedback', // {string} callbackname 点击返回调用的函数名，注意是全局上的
        };

        window.grounds.openVideo(url, JSON.stringify(option), 'videoCallback');
    };

    // 2.DOM初始后渲染视频 && 视频信息不能为空
    useEffect(
        () => {
            if (rect.height > 0 && currentVideo.videoPlayUrl) {
                console.log('currentVideo.videoPlayUrl', currentVideo.videoPlayUrl);

                // 渲染视频信息
                renderVideo();
            }
        },
        [
            rect.height, // DOM高度
            currentVideo, // 视频切换时
        ],
    );

    return (
        <div
            className={styles.top}
            style={{
                paddingTop: statusBarHeight,
                background: isNightMode ? '#000' : '',
            }}>
            <div className={styles.video} ref={videoRef} />
        </div>
    );
};

OpenVideo.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(OpenVideo);
